<template>
  <v-app class='appClass' :id='appId'>

    <div style='position: relative'>
      <Snackbar
        v-model='snackbar'
        :text='snackbarMessage'
        :color='snackbarColor'
        @input='onSnackClosed'
      />
    </div>
    <slot/>
  </v-app>
</template>

<script>
import { VApp } from 'vuetify/lib'
import Snackbar from '@/components/Snackbar'
import Detect from 'mobile-device-detect'

export default {
  components: { VApp, Snackbar },
  data () {
    return {
      atTop: true,
      snackbar: false,
      snackbarMessage: '',
      snackbarColor: '',
      snackQueue: []
    }
  },
  computed: {
    appId () {
      return this.isMobile ? 'appMobile' : 'appWeb'
    },
    isMobile () {
      return Detect.isMobile
    }
  },
  provide () {
    return {
      $message: function (obj) {
        let color = 'primary'
        switch (obj.type) {
          case 'error': color = 'error'; break
          case 'warning': color = 'warning'; break
          case 'success': color = 'primary'; break
        }
        if (obj.text) {
          this.queueSnack({
            text: obj.text || '',
            color: color
          })
        }
      }.bind(this)
    }
  },
  methods: {
    queueSnack (obj) {
      this.snackQueue.push(obj)
      if (!this.snackbar && this.snackQueue.length === 1) this.onSnackClosed()
    },
    onSnackClosed () {
      if (this.snackQueue.length) {
        this.$nextTick().then(() => {
          const obj = this.snackQueue.splice(0, 1)[0]
          this.snackbarColor = obj.color
          this.snackbarMessage = obj.text
          this.snackbar = true
        })
      } else {
        this.snackbarColor = ''
        this.snackbarMessage = ''
      }
    }
  }
}
</script>
